import { Hyperlink } from "@ebsco-ui/ebsco-ui";
import PropTypes from "prop-types";
import queryString from "query-string";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import sharedMessages from "../../../../shared-messages";
import { getAuthorizeUrl } from "../../../store/merge";
import MergeError from "../error";
import StepContent from "../step-content";
import merge from "./merge.svg";
import messages from "./source-sign-in-messages";

import "./source-sign-in.scss";

const block = "source-sign-in";

const SourceSignIn = ({ username }) => {
  const { formatMessage } = useIntl();
  const authorizeUrl = useSelector(getAuthorizeUrl);
  // https://github.com/EBSCOIS/resourcemanagement.shared.personaluser-ui/issues/519
  const location = useSelector(state => state.router.location);
  const { error } = queryString.parse(location.search);

  if (error) {
    return <MergeError username={username} />;
  } else {
    return (
      <StepContent
        imageUrl={merge}
        stepTitle={formatMessage(messages.takeItWithYou)}
      >
        <div className={block}>
          <p className={`${block}__merge-details`}>
            <FormattedMessage {...messages.mergeDataFromAccount} />
          </p>
          <p className={`${block}__sign-in-instructions`}>
            <FormattedMessage {...messages.signIntoDifferentAccount} />
          </p>
          <p className={`${block}__current-account`}>
            <FormattedMessage
              {...sharedMessages.currentlySignedInAs}
              values={{
                username,
                styledUsername: displayStyledUserName(block)
              }}
            />
          </p>
          <Hyperlink
            href={authorizeUrl}
            styleType="highlighted"
            target="_self"
            className={`${block}__sign-in-link`}
          >
            <FormattedMessage {...messages.signIntoSecondAccount} />
          </Hyperlink>
        </div>
      </StepContent>
    );
  }
};

const displayStyledUserName = baseClassName => msg => (
  <span className={`${baseClassName}__current-account__username`}>{msg}</span>
);

SourceSignIn.propTypes = {
  username: PropTypes.string.isRequired
};

export default SourceSignIn;
